"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementContainer = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _AgreementV = require("../../../../components/AgreementV2");
var _AgreementLayout = require("../../../../components/AgreementLayout");
var _TitleAgreement = require("../../../../components/TitleAgreement");
var _view = require("../../../../actions/view");
var _agreement = require("../../../../actions/agreement");
var _tracking = require("./tracking");
var _selectors = require("./selectors");
var _source = require("../../../../selectors/source");
var _tracking2 = require("../../tracking");
var _view2 = require("../../../../types/view");
var _hooks = require("../../../../hooks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AgreementContainer = _ref => {
  let {
    useSelector,
    useDispatch
  } = _ref;
  const dispatch = useDispatch();
  const isLoading = useSelector(_selectors.selectIsAgreementNextLoading);
  const source = useSelector(_source.sourceSelector);
  const viewData = useSelector(_selectors.viewDataSelector);
  const {
    marketingSubscriptionAccepted,
    licenceAccepted
  } = useSelector(_selectors.selectAgreement);
  const cianHost = (0, _hooks.useCianHost)({
    useSelector
  });
  const handleAgreementChange = React.useCallback((e, value) => {
    dispatch((0, _agreement.acceptLicence)(value));
  }, [dispatch]);
  const handleSubscriptionChange = React.useCallback((e, value) => {
    dispatch((0, _agreement.acceptMarketingSubscription)(value));
  }, [dispatch]);
  const handleNextClick = React.useCallback(() => {
    (0, _tracking.trackNextButtonClick)({
      licenceAccepted,
      marketingSubscriptionAccepted,
      source
    });
    dispatch((0, _agreement.applyAgreement)());
  }, [dispatch, licenceAccepted, marketingSubscriptionAccepted, source]);
  const handlePreviousClick = React.useCallback(() => {
    (0, _tracking.trackBackButtonClick)(source);
    dispatch((0, _view.previousView)());
    dispatch((0, _agreement.acceptMarketingSubscription)(false));
    dispatch((0, _agreement.acceptLicence)(false));
  }, [dispatch, source]);
  React.useEffect(() => {
    const currentSource = viewData.prevView === _view2.EActiveView.AccountSelect ? 'select_account' : source;
    (0, _tracking2.trackAgreementOpen)(currentSource);
  }, []);
  return /*#__PURE__*/React.createElement(_AgreementLayout.AgreementLayout, {
    title: /*#__PURE__*/React.createElement(_TitleAgreement.TitleAgreement, {
      viewData: viewData
    }),
    agreement: /*#__PURE__*/React.createElement(_AgreementV.AgreementV2, {
      agreementAccepted: licenceAccepted,
      subscriptionAccepted: marketingSubscriptionAccepted,
      onAgreementChange: handleAgreementChange,
      onSubscriptionChange: handleSubscriptionChange,
      cianHost: cianHost
    }),
    controls: [/*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueBtn",
      key: "next",
      type: "button",
      theme: "fill_primary",
      disabled: !licenceAccepted,
      loading: isLoading,
      onClick: handleNextClick,
      fullWidth: true
    }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442"), /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "GoBackBtn",
      key: "previous",
      type: "button",
      theme: "fill_secondary",
      disabled: isLoading,
      onClick: handlePreviousClick,
      fullWidth: true
    }, "\u041D\u0430\u0437\u0430\u0434")]
  });
};
exports.AgreementContainer = AgreementContainer;